import React from 'react';

export default function ComingSoon({ title }) {
  return (
    <div className="page">
      <div className="page-header">
        <h2>{title}</h2>
      </div>
      <div className="card">
        <div className="empty-row">준비 중인 화면입니다.</div>
      </div>
    </div>
  );
}
